import React, { createContext, useContext, useEffect, useState } from "react";
import { getTenantConfig, IS_SAAS_HOST } from "../lib/api";

const TenantContext = createContext(null);
export const useTenant = () => useContext(TenantContext);

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTenantConfig().then(setTenant).catch(() => {}).finally(() => setLoading(false));
    document.title = "Design Your Custom Gym Turf Online | Prime Gym Turf UK";
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); return m;
    })();
    meta.content = "Design your custom gym sprint track online. Choose your dimensions, colours, logo and markings, see your price instantly and order directly from Prime Gym Turf.";
  }, []);

  const _p = window.location.pathname;
  const marketingOnly = (IS_SAAS_HOST && _p === "/") || /^\/(software|saas|pricing|contact|signup|onboarding|dashboard|billing|shopify|gym-turf-designer|artificial-turf-designer|gym-flooring-software|turf-visualiser)(\/|$)/.test(_p);
  if (loading && !marketingOnly) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-pgt-bg">
        <div className="text-pgt-green font-display text-3xl tracking-widest pgt-pulse">PRIME GYM TURF</div>
      </div>
    );
  }
  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}
